var version = {
    "name":      "dativery",
    "buildDateCode": "20251121-104926",
    "buildDate": "Fri Nov 21 2025 10:49:26 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251121-104926",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;